import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedVideocamOff = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 29,
	height: 29,
	viewBox: "0 0 29 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M26.3751 21.0313L21.6251 16.2813V18.2703L8.35479 5.00001H19.2501C19.9032 5.00001 20.4623 5.23256 20.9274 5.69767C21.3925 6.16277 21.6251 6.72189 21.6251 7.37501V12.7188L26.3751 7.96876V21.0313ZM24.6532 27.9781L1.02197 4.34689L2.68447 2.68439L26.3157 26.3156L24.6532 27.9781ZM5.0001 5.00001L21.6251 21.625C21.6251 22.2781 21.3925 22.8373 20.9274 23.3024C20.4623 23.7675 19.9032 24 19.2501 24H5.0001C4.34697 24 3.78786 23.7675 3.32275 23.3024C2.85765 22.8373 2.6251 22.2781 2.6251 21.625V7.37501C2.6251 6.72189 2.85765 6.16277 3.32275 5.69767C3.78786 5.23256 4.34697 5.00001 5.0001 5.00001Z",
		fill: "url(#paint0_linear_8512_20490)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_8512_20490",
		x1: .888568,
		y1: 28.311,
		x2: 30.7472,
		y2: 8.8573,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#142F95" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#2563EB"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CACBFF"
			})
		]
	}) })]
});
export default SvgExtendedVideocamOff;
